import {
  ChatConfig,
  ChatConfigCreateRequest,
  ChatConfigListResponse,
  ChatConfigUpdateRequest,
  ConfigType
} from '../types/chatConfig';
import { ApiClient, ApiError } from './apiClient';

export class ChatConfigService {
  constructor(private api: ApiClient) { }

  async list(params?: { page?: number; pageSize?: number }) {
    const query: Record<string, string | number | undefined> = {};
    if (params?.page !== undefined) {
      query.page = params.page;
    }
    if (params?.pageSize !== undefined) {
      query.pageSize = params.pageSize;
    }

    return this.api.get<ChatConfigListResponse>('/api/chat-configs', query).then(result => {
      if (result.success && result.data) {
        return result.data;
      }
      return {
        items: [],
        page: params?.page ?? 1,
        pageSize: params?.pageSize ?? 10,
        total: 0
      };
    });
  }

  getById(id: number) {
    return this.api
      .get<ChatConfig>(`/api/chat-configs/${id}`)
      .then(result => (result.success && result.data ? result.data : null));
  }

  getByType(type: ConfigType) {
    const encodedType = encodeURIComponent(type);
    return this.api
      .get<ChatConfig>(`/api/chat-configs/type/${encodedType}`)
      .then(result => (result.success && result.data ? result.data : null));
  }

  create(payload: ChatConfigCreateRequest) {
    return this.api
      .post<ChatConfig>('/api/chat-configs', payload)
      .then(result => {
        if (!result.success || !result.data) {
          throw new ApiError(0, result.error ?? 'Failed to save configuration');
        }
        return result.data;
      });
  }

  update(id: number, payload: ChatConfigUpdateRequest) {
    return this.api
      .put<ChatConfig>(`/api/chat-configs/${id}`, payload)
      .then(result => {
        if (!result.success || !result.data) {
          throw new ApiError(0, result.error ?? 'Failed to update configuration');
        }
        return result.data;
      });
  }

  delete(id: number) {
    return this.api.delete<void>(`/api/chat-configs/${id}`).then(() => undefined);
  }

  invalidateCache() {
    return this.api
      .post<{ message: string }>('/api/chat-configs/invalidate-cache', {})
      .then(result => (result.success && result.data ? result.data : { message: '' }));
  }
}

